import React from "react";
import Navbar from "components/Navbar.js";
import Footer from "components/Footer.js";
import "../styles/profile-studio.css";
import { WHATSAPP_BOOKING_URL } from "../utils/contactDetails";

const specialties = [
  "Bridal",
  "Reception",
  "Engagement",
  "Western & party",
  "Hairstyling & saree draping",
];

export default function Profile() {
  const latLng = {
    lat: "22.6197117",
    lng: "88.4425421",
  };

  const mapUrl = `https://maps.google.com/?q=${latLng.lat},${latLng.lng}`;

  return (
    <>
      <Navbar transparent className="profile-studio__navbar" />
      <main className="profile-studio">
        <section className="profile-studio__hero" aria-labelledby="profile-hero-heading">
          <img
            className="profile-studio__hero-image"
            src={require("assets/img/profile-cover.jpg").default}
            alt=""
            aria-hidden="true"
            decoding="async"
          />
          <div className="profile-studio__hero-shade" aria-hidden="true" />
          <div className="profile-studio__hero-copy">
            <h1 id="profile-hero-heading">Beauty, brought out naturally.</h1>
            <p>Thoughtful makeup for the moments you want to remember.</p>
          </div>
          <span className="profile-studio__hero-rule" aria-hidden="true" />
        </section>

        <section className="profile-studio__content" aria-label="About Arpita Manna">
          <div className="profile-studio__card">
            <aside className="profile-studio__identity">
              <div className="profile-studio__portrait-frame">
                <img
                  src={require("assets/img/ArpitaProfileAvatar1.png").default}
                  alt="Arpita Manna"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <h2>Arpita Manna</h2>
              <p className="profile-studio__role">Makeup Artist</p>
              <a
                className="profile-studio__location"
                href={mapUrl}
                target="_blank"
                rel="noreferrer"
              >
                <i className="fas fa-map-marker-alt" aria-hidden="true" />
                Chinarpark, Kolkata
                <i className="fas fa-external-link-alt" aria-hidden="true" />
              </a>
            </aside>

            <div className="profile-studio__story">
              <p className="profile-studio__eyebrow profile-studio__eyebrow--dark">
                A little about me
              </p>
              <h2>A personal touch, from first look to final detail.</h2>
              <p className="profile-studio__bio">
                I'm Arpita, a makeup artist based in Chinarpark, Kolkata. I
                create bridal, reception, engagement, and party looks, with
                hairstyling and saree draping to complete the look. We begin
                with your occasion, your personal style, and how you want to
                feel. Then I shape the details to complement your features
                and help you feel at ease, confident, and unmistakably
                yourself.
              </p>

              <div className="profile-studio__credentials" aria-label="Profile details">
                <div>
                  <strong>5 years</strong>
                  <span>of experience</span>
                </div>
                <div>
                  <strong>Every occasion</strong>
                  <span>bridal to party looks</span>
                </div>
                <div>
                  <strong>Kolkata</strong>
                  <span>based in Chinarpark</span>
                </div>
              </div>

              <div className="profile-studio__specialties">
                <h3>Services I offer</h3>
                <ul>
                  {specialties.map((specialty) => (
                    <li key={specialty}>{specialty}</li>
                  ))}
                </ul>
              </div>

              <div className="profile-studio__actions">
                <a
                  className="profile-studio__button profile-studio__button--primary"
                  href={WHATSAPP_BOOKING_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Book an appointment on WhatsApp"
                >
                  <i className="fab fa-whatsapp" aria-hidden="true" />
                  Book an appointment
                </a>
                <a className="profile-studio__button profile-studio__button--secondary" href="/rate-chart">
                  View rate chart
                  <i className="fas fa-arrow-right" aria-hidden="true" />
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
